export const SERVER_ERROR_SHORT = 'An error has occurred';
export const SERVER_ERROR = 'An error has occurred! Please try again later.';
export const HELP_INFO = 'If this problem persists please contact us at info@neurochecklists.com';
